import cloneDeep from 'lodash/cloneDeep';
import { isAfter, isBefore } from 'date-fns';
import { Notification } from '../../../../core/state/notifications/types';

export const sortNotificationsByDate = (notifications: Notification[]) => {
  const newNotifications = cloneDeep(notifications);
  return newNotifications.sort((firstNotification, secondNotification) => {
    const firstDate = new Date(firstNotification.createdOn);
    const secondDate = new Date(secondNotification.createdOn);

    if (isBefore(firstDate, secondDate)) {
      return 1;
    }
    if (isAfter(firstDate, secondDate)) {
      return -1;
    }
    return 0;
  });
};
